@import url(folder/stylesheet-import1.css);

.rule-direct {
	background: lightgreen;
}


/** WEBPACK FOOTER **
 ** ./loaders/_css/stylesheet.css
 **/